export default "__VITE_ASSET__0wElfo3c__"